import module from 'guest/module.js'
import moment from 'moment'

module.config(($stateProvider) => {
  $stateProvider.state('guest.servicios', {
    url: '/servicios?{inicio:date}&{fin:date}&{moneda:[12]}',
    params: {
      inicio: {value: moment().startOf('month').toDate(), squash: true},
      fin: {value: moment().endOf('month').toDate(), squash: true},
      moneda: {value: '1', squash: true},
    },
    data: {title: 'guest.services.title'},
    resolve: {
      fechaInicial: ($stateParams) => $stateParams.inicio,
      fechaFinal: ($stateParams) => $stateParams.fin,
      idMoneda: ($stateParams) => $stateParams.moneda,
      monedas: ($catalogos) => $catalogos.get('monedas'),
      data: (auth, GuestServicios, idProyecto, idColaborador, fechaInicial, fechaFinal, idMoneda) => GuestServicios.get(idProyecto, idColaborador, fechaInicial, fechaFinal, idMoneda)
        .then((response) => {
          const periodo = (new Date()).getFullYear()

          return response.data.map((item) => {
            const formato = periodo === item.Fecha.getFullYear() ? 'MMMM D' : 'MMMM D, YYYY'
            item.Agrupacion = moment(item.Fecha).format(formato).toUpperCase()

            return item
          })
        }),
    },
    template: '<guest-servicios id-empresa="idProyecto" id-empleado="idColaborador" fecha-inicial="fechaInicial" fecha-final="fechaFinal" id-moneda="idMoneda" data="data" monedas="monedas"></guest-servicios>',
    controller: ($scope, idProyecto, idColaborador, fechaInicial, fechaFinal, idMoneda, data, monedas) => {
      $scope.idProyecto = idProyecto
      $scope.idColaborador = idColaborador
      $scope.fechaInicial = fechaInicial
      $scope.fechaFinal = fechaFinal
      $scope.idMoneda = idMoneda
      $scope.data = data
      $scope.monedas = monedas
    },
  })
})



// WEBPACK FOOTER //
// ./src/guest/routes/guest/servicios.js